<template>
  <div>
    <div class="tw-flex tw-justify-center tw-justify-items-center tw-my-8">
      <back-nav to="PersonalDetailsReview" />
    </div>
    <v-card v-if="!pageLoading" class="tw-pb-12 tw-px-4">
      <card-title icon="mdi-autorenew">Overview</card-title>
      <top-stepper
        style="padding-left: -20px"
        current="VehicleDetails"
        :cover-type="coverType"
      />
      <div class="tw-px-0 md:tw-px-10 xl:tw-px-16 tw-mt-4 md:tw-mt-10">
        <v-form v-model="isValid">
          <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-3">
            <v-text-field
              v-model="car.make"
              class="my-2 tw-px-0 md:tw-px-6"
              label="Vehicle Make"
              type="text"
              disabled
              :rules="[required('Vehicle Make')]"
            ></v-text-field>
            <v-text-field
              v-model="car.vehicleNumber"
              class="my-2 tw-px-0 md:tw-px-6"
              label="Registration Number"
              type="text"
              :rules="[required('Registration Number')]"
              disabled
            ></v-text-field>
            <v-select
              v-if="!car.bodyType"
              v-model="car.bodyType"
              :items="vehicleBodyTypes"
              class="my-2 tw-px-0 md:tw-px-6"
              label="Body Type"
              :rules="[required('Body Type')]"
            >
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-select>
            <v-text-field
              v-else
              v-model="car.bodyType"
              class="my-2 tw-px-0 md:tw-px-6"
              label="Body Type"
              type="text"
              :rules="[required('Body Type')]"
              disabled
            ></v-text-field>
            <v-text-field
              v-model="car.model"
              class="my-2 tw-px-0 md:tw-px-6"
              label="Vehicle Model"
              type="text"
              :rules="[required('Vehicle Model')]"
              disabled
            ></v-text-field>
            <vuetify-money
              v-if="coverType.covertypeId === 120"
              id="car-amount"
              v-model="car.insuredValue"
              label="Value of Vehicle (Kshs.)"
              type="text"
              name="amount"
              class="mx-4"
              :rules="[
                required('Value of Vehicle (Kshs.)'),
                minAmount('Value of Vehicle (Kshs.)', 600000),
              ]"
              :options="options"
              :disabled="!switchedCover"
              :properties="{ id: 'amount-input' }"
            ></vuetify-money>
            <v-text-field
              v-model="car.year"
              class="my-2 tw-px-0 md:tw-px-6"
              label="Year Of Manufacture"
              type="number"
              disabled
            ></v-text-field>
            <v-text-field
              v-model="car.chassisNumber"
              class="my-2 tw-px-0 md:tw-px-6"
              label="Chassis No."
              type="text"
              :rules="[required('Chassis No.'), minLength('Chassis No.', 6)]"
              :disabled="chassisDisabled"
            ></v-text-field>
            <v-text-field
              v-model="car.engineNo"
              class="my-2 tw-px-0 md:tw-px-6"
              label="Engine No."
              type="text"
              @keyup="getCapitalizedValue('engineNo')"
              :rules="[required('Engine No.')]"
            ></v-text-field>
            <v-text-field
              v-model="car.logbookNumber"
              class="my-2 tw-px-0 md:tw-px-6"
              label="Logbook No. (optional)"
              @keyup="getCapitalizedValue('logbookNumber')"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model="car.cc"
              class="my-2 tw-px-0 md:tw-px-6"
              label="Engine Size (CC)"
              type="number"
              :rules="[required('Engine Size (CC)')]"
            ></v-text-field>
            <v-text-field
              v-model="car.vehicleColor"
              class="my-2 tw-px-0 md:tw-px-6"
              label="Colour"
              type="text"
              :rules="[required('Colour')]"
            ></v-text-field>
            <v-text-field
              v-model="car.seatingCapacity"
              class="my-2 tw-px-0 md:tw-px-6"
              label="Seating Capacity"
              type="number"
              required
              :rules="[min('Seating Capacity', 1), max('Seating Capacity', 9)]"
            ></v-text-field>
            <v-text-field
              v-model="car.insuredValue"
              class="my-2 tw-px-0 md:tw-px-6"
              label="Sum Insured (Kshs.)"
              type="text"
              disabled
            ></v-text-field>
          </div>
          <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-3">
            <v-text-field
              v-model="car.windscreenValue"
              class="my-2 tw-px-0 md:tw-px-6"
              label="Windscreen Value (Kshs.)"
              type="number"
              @blur="disabledWindscreen = isValidNumber(car.windscreenValue)"
            ></v-text-field>
            <v-text-field
              v-model="car.entertainmentValue"
              class="my-2 tw-px-0 md:tw-px-6"
              label="Entertainment Value (Kshs.)"
              type="number"
              @blur="
                disabledEntertainment = isValidNumber(car.entertainmentValue)
              "
            ></v-text-field>
          </div>
          <div
            v-if="isTpoRenewal"
            class="tw-w-full tw-mb-4 tw-p-4 tw-rounded-lg tw-bg-orange-100 tw-text-blue-600"
          >
            {{ tpoDisabledMessage }}
          </div>
          <v-card-actions
            class="col-sm-4 offset-sm-4 tw-mt-5 md:tw-mt-8 tw-pb-8"
          >
            <v-btn
              block
              large
              color="secondary"
              class="my-3"
              :loading="loading"
              :disabled="
                !isValid || disabledWindscreen || disabledEntertainment || isTpoRenewal
              "
              @click="proceed(coverType)"
            >
              {{ isValid ? "Continue" : "Check if all fields are filled" }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </div>
    </v-card>
    <v-card v-else class="tw-w-full tw-flex tw-justify-center tw-p-10">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-card>
  </div>
</template>

<script>
/*eslint-disable*/
import BackNav from "@/components/buy/BackNav";
import validations from "@/utils/validations";
import CardTitle from "@/components/shared/CardTitle";
import axios from "axios";
import { FB_RENEW_REVIEW_VEHICLE_DETAILS } from "@/utils/const";
import { formatDateForAPI } from "@/utils/time";
import TopStepper from "@/components/buy/TopStepper.vue";
import renewalMixin from "@/mixins/renewalMixin";
import unleashMixin from "@/mixins/unleashMixin";

const TPO_GATE_FEATURE_FLAG = "TPO_BUSINESS";
const TPO_DISABLED_MESSAGE =
  "Important Notice: We no longer support the purchase of Third Party Only (TPO) motor insurance policies through our digital channels. For assistance with your insurance requirement, please contact our Customer Service team at customer.service@apollo.co.ke";

export default {
  name: "VehicleDetailsReview",
  props: {
    renewal: {
      type: Object,
    },
    switchedCover: {
      default: false,
      type: Boolean,
    },
    personalData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { TopStepper, CardTitle, BackNav },
  data() {
    return {
      vehicleBodyTypes: [],
      disabledWindscreen: false,
      disabledEntertainment: false,
      loading: false,
      car: {
        chassisNumber: "",
        make: "",
        model: "",
        insuredValue: 0,
        year: "",
        vehicleNumber: "",
        engineNo: "",
        logbookNumber: "",
        cc: "",
        vehicleColor: "",
        seatingCapacity: "",
        sumInsured: 0,
        windscreenValue: "",
        entertainmentValue: "",
      },
      pageLoading: true,
      ...validations,
      isValid: false,
      options: {
        locale: "en",
        prefix: "Kes",
        suffix: "",
        precision: 0,
      },
      chassisDisabled: false,
      policyNo: "",
      premium: 0,
      productId: "",
      sumInsured: 0,
    };
  },
  computed: {
    quote() {
      return this.$store.getters["renewal/fetchQoute"];
    },
    disableTpoRenewal() {
      return !this.isFlagEnabled(TPO_GATE_FEATURE_FLAG);
    },
    isTpoRenewal() {
      return this.disableTpoRenewal && this.coverType.coverTypeId === 121;
    },
    tpoDisabledMessage() {
      return TPO_DISABLED_MESSAGE;
    },
  },
  mixins: [renewalMixin, unleashMixin],
  async mounted() {
  try {
    const storedPersonalData = this.getLocalStorageJson("personalData");
    await this.$store.dispatch("renewal/fetchQuotation", {
      batchNo: this.$route.params.batchNo,
      quoteId: this.renewal.quoteId,
    });
    const quoteData = this.$store.getters["renewal/fetchQoute"];
    this.car = { ...this.car, ...quoteData, insuredValue: quoteData.sumInsured || storedPersonalData.sumInsured || 0 };
  } catch (error) {
  } finally {
    this.pageLoading = false;
    this.fetchVehicleBodyTypes();
  }
},
  methods: {
    fetchVehicleBodyTypes() {
      axios
        .post("/motor/api/quote/vehicleTypeList")
        .then((response) => {
          this.vehicleBodyTypes = response.data.data;
        })
        .catch((error) => {
          this.vehicleBodyTypes = [];
        });
    },
    proceed(coverType) {
      if (this.disableTpoRenewal && coverType.coverTypeId === 121) {
        this.$toast.error(TPO_DISABLED_MESSAGE);
        return;
      }
      this.loading = true;

      const storedPersonalData = JSON.parse(
        localStorage.getItem("personalData")
      );
      const [firstName, ...lastNameParts] =
        storedPersonalData.fullName.split(" ");
      const lastName = lastNameParts.join(" ");

      const payload = {};
      payload.benefit = {
        aa: false,
        courtesyCar10: false,
        courtesyCar20: false,
        excessProtectorFull: false,
        excessProtectorOwn: false,
        travel: false,
        violence: true,
      };
      const formPayload = JSON.parse(localStorage.getItem('formPayload')) || {};
      payload.customerId = formPayload.customerId
      payload.distribution = "100";
      payload.freeBenefits = [
        {
          benefitValue: 50000,
          description: "ENTERTAINMENT",
        },
        {
          benefitValue: 50000,
          description: "WINDSCREEN",
        },
      ];

      payload.policy = {
        contact: {
          dob: formatDateForAPI(storedPersonalData.dob),
          email: storedPersonalData.email || "",
          firstName: firstName,
          idNumber: storedPersonalData.idNumber || "",
          isCorporate: false,
          kra: storedPersonalData.kraPinNumber || "",
          lastName: lastName,
        },
        coverType:
          this.coverType.coverTypeId === 120 ? "Comprehensive" : "Third Party",
        policyNo: this.$route.params.policyNo,
        premium: storedPersonalData.premium,
        productId: storedPersonalData.productId,
        sumInsured: storedPersonalData.sumInsured,
      };
      payload.vehicle = {
        bodyType: this.car.bodyType,
        cc: this.car.cc,
        chassisNumber: this.car.chassisNumber,
        engineNo: this.car.engineNo,
        logbookNumber: this.car.logbookNumber,
        make: this.car.make,
        model: this.car.model,
        quoteExcluded: "GRAYLISTED",
        regNo: this.car.vehicleNumber,
        seatingCapacity: this.car.seatingCapacity,
        vehicleColor: this.car.vehicleColor,
        yearOfManufacture: this.car.year,
        value: this.car.sumInsured,
        windscreenValue: this.car.windscreenValue,
        entertainmentValue: this.car.entertainmentValue,
      };

      axios
        .post(`/motor/api/policy/renewal`, payload)
        .then((response) => {
          if (response.data.code === 0) {
            this.$toast.success(
              "Policy renewal request submitted successfully",
              "Policy Renewal"
            );
            payload.freeBenefits = response.data.data.freeBenefits;
            payload.policy.premium = response.data.data.premiumAfterTax;
            payload.premiumAfterTax = response.data.data.premiumAfterTax;
            payload.premiumInstalments = response.data.data.premiumInstalments || [];
            localStorage.setItem("renewalData", JSON.stringify(payload));
            this.loading = false;
            this.$analytics.logEvent(FB_RENEW_REVIEW_VEHICLE_DETAILS, {
              product: "Renewal Journey Review Vehicle Details",
            });
            localStorage.setItem("distribution", "100");
            if (coverType.coverTypeId === 120) {
              this.$emit("to-switch-cover-review", response.data.data);
            } else {
              this.$emit("to-branch-selection-review", response.data.data);
            }
          } else {
            this.$toast.error(
              "Failed to submit policy renewal request",
              "Policy Renewal Error"
            );
            this.loading = false;
          }
        })
        .catch((error) => {
          this.$toast.error(
            "An error occurred while submitting the policy renewal request",
            "Policy Renewal Error"
          );
          this.loading = false;
        });
    },
    benefits() {
      return;
    },
    getCapitalizedValue(key) {
      this.car[key] = this.car[key].toUpperCase();
    },
  },
};
</script>
